import myAxios from "@/utils/request";
export default {
  getList(params) {
    return myAxios.post("/api/patent/achipaging_im", params);
  },
  batchDelete(params) {
    return myAxios.post("/api/patent/backbatchdelete", params);
  },
  // 添加需求详情
  addPatent(params) {
    return myAxios.post("/api/patent/topaddpatent_im", params);
  },
  // 修改需求详情
  modifyPatent(params) {
    return myAxios.post("/api/patent/topaddpatent_im", params);
  },
  // 审核需求详情
  auditPatent(params) {
    return myAxios.post("/api/patent/approvepatent_im", params);
  },
  // 获取需求详细信息
  getPatentInfo(params) {
    const { id } = params;
    return myAxios.get("/api/patent/getpatentbyid_im?id=" + id);
  },
  // 获取专利对接列表
  getDockingList(params) {
    return myAxios.post(
      "/api/patentdeclaration/getpatentdeclarationmodelbyselect",
      params
    );
  },
  batchDeleteDocking(params) {
    return myAxios.post("/api/patentdeclaration/batchdelete", params);
  }
};
